export const EVENT_TEAM_ROLE = {
  ISACA: 0,
  INTERNAL: 1,
  OBSERVATION: 2,
  APPRENTICESHIP: 3,
  FDA: 4
};
